import { render, staticRenderFns } from "./sk-profile-contact-info.vue?vue&type=template&id=45e60570"
import script from "./sk-profile-contact-info.vue?vue&type=script&lang=js"
export * from "./sk-profile-contact-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports